module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/production/production-testimonial-1-19e4fdc1166988bd27253953daf8e587.jpg";